import React, { useEffect, useState } from "react";
import { GetSchoolTeachers, GetClassesBySchoolId } from "../../actions/adminQueries";
import { Button, Row, Col, Input } from "reactstrap";
import CreateTeacher from "../../components/Modal/CreateTeacherModal";
import TeacherTable from "../../components/Tables/TeacherTable";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { AUTH_BASE_URL } from "../../constants/api.constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { useLocation } from "react-router-dom";

function Teachers() {
  const location = useLocation();
  const [filterSearch, setFilterSearch] = useState("");
  const [school] = useState(
    location.state
      ? location.state.school
      : JSON.parse(localStorage.getItem("school"))
  );
  const [createTeacherModal, setCreateTeacherModal] = useState(false);
  const [displayConfirmDialog, setDisplayConfirmDialog] = useState(false);
  const [teacherToRemove, setTeacherToRemove] = useState(null);
  const [teacherToUpdate, setTeacherToUpdate] = useState(null);
  const [classes, setClasses] = useState([]);

  const schoolTeachers = GetSchoolTeachers(school.id);
  const classesQuery = GetClassesBySchoolId(school.id);

  useEffect(() => {
    if (!classesQuery.isPending && classesQuery.data) {
      setClasses(classesQuery.data);
    }
  }, [classesQuery.data, classesQuery.isPending]);

  const loadTeachers = () => {
    schoolTeachers.refetch();
  };

  const toggleCreateTeacherModal = (teacher) => {
    setTeacherToUpdate(teacherToUpdate !== null ? null : teacher);
    setCreateTeacherModal(!createTeacherModal);
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const toggleConfirmDialog = (teacher) => {
    setTeacherToRemove(teacher);
    setDisplayConfirmDialog(!displayConfirmDialog);
  };

  const deleteTeacher = () => {
    axios
      .delete(`/teacher/${teacherToRemove.id}`)
      .then(() => {
        axios
          .delete(
            `${AUTH_BASE_URL}/token?email=${encodeURIComponent(
              teacherToRemove.email
            )}`
          )
          .then(() => {
            loadTeachers();
            setTeacherToRemove(null);
            setDisplayConfirmDialog(false);
            toast.success(
              <FormattedMessage id="Views.Admin.RemoveTeacherFromSchool.Success" />,
              TOAST_CONFIG
            );
          });
      })
      .catch(() => {
        toast.error(
          <FormattedMessage id="Views.Admin.RemoveTeacherFromSchool.Error" />,
          TOAST_CONFIG
        );
      });
  };

  const getTeacherToRemove = () => {
    if (teacherToRemove) {
      let teacher = schoolTeachers.data.find(
        (t) => t.id === teacherToRemove.id
      );
      if (teacher) return teacher.name;
    }
    return "Okänd";
  };

  var teachers = schoolTeachers.data || [];

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">Lärare {school.name}</h5>
      </div>
      <div className="container-fluid admin-container">
        <Col>
          <Row className="search-row">
            <Col className="col-3">
              <Input
                placeholder="Sök lärare"
                onChange={(data) => handleFilterSearch(data)}
              />
            </Col>
            <Col className="offset-7 col-2">
              <Button
                color="primary"
                outline
                className="float-end"
                disabled={classesQuery.isPending}
                onClick={() => {
                  toggleCreateTeacherModal();
                }}
              >
                {" "}
                <FontAwesomeIcon icon="plus" />
              </Button>
            </Col>
          </Row>
          <TeacherTable
            updateTeacher={toggleCreateTeacherModal}
            detachTeacher={toggleConfirmDialog}
            teachers={teachers}
            filter={filterSearch}
            fullAccess={true}
          />
        </Col>
      </div>

      <CreateTeacher
        teacherToUpdate={teacherToUpdate}
        schoolClasses={classes}
        isOpen={createTeacherModal}
        toggle={toggleCreateTeacherModal}
        loadTeachers={loadTeachers}
        fullAccess={true}
      />

      <ConfirmDialog
        isOpen={displayConfirmDialog}
        title="Ta bort lärare"
        message={
          <div>
            <p>
              Är du säker på att du vill ta bort läraren '
              <strong>{getTeacherToRemove()}</strong>'?
            </p>
            <p>
              <em>Det här valet går inte att ångra.</em>
            </p>
          </div>
        }
        toggle={toggleConfirmDialog}
        onProceed={deleteTeacher}
        danger={true}
      />
    </div>
  );
}

export default Teachers;
